module.exports = __webpack_public_path__ + "static/img/s32.c7507836.png";